import { render, staticRenderFns } from "./EquipeProjeto.vue?vue&type=template&id=43b6f65e&"
import script from "./EquipeProjeto.vue?vue&type=script&lang=js&"
export * from "./EquipeProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports